/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useMemo, useRef, useContext } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import type { State } from "@progress/kendo-data-query";
import { process } from "@progress/kendo-data-query";
import { Button, Card, CardContent } from "@repo/ui";

import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import {
  useGetSLADashboardDetail,
  useExportSLADashboardDetail,
} from "utils/apis/sla-dashboard.api";
import { getTicketDetailsPage } from "pages/tickets/utils";
import { StatusContext } from "pages/tickets/constants";
import GridDataCopyCell from "components/copy";

const PAGE_SIZE = 100;

interface SlaInfo {
  slaStage?: string;
}

const getSlaStageInfo = (value?: string) => {
  let display = value ?? "-";
  let bgColor = "transparent";

  switch (value) {
    case "WithinSla":
      display = "Within SLA";
      bgColor = "#4D9989";
      break;
    case "Breach":
    case "BreachEscalation":
      display = "Breached Escalation";
      bgColor = "#e65c66";
      break;
    case "AboutToBreach":
      display = "About to Breach";
      bgColor = "orange";
      break;
    default:
      display = value ?? "-";
      bgColor = "transparent";
  }

  return { display, bgColor };
};

// Helper for Task Details Page
// const getTaskDetailsPage = (dataItem: {
//   taskNo: any;
//   assignmentGroup: string;
//   customerId: string;
//   eventType: string;
// }) => {
//   if (!dataItem.taskNo) return "#";

//   const params = new URLSearchParams();
//   if (dataItem.assignmentGroup)
//     params.set("assignmentGroup", dataItem.assignmentGroup as string);
//   if (dataItem.customerId)
//     params.set("customerId", dataItem.customerId as string);
//   if (dataItem.eventType) params.set("eventType", dataItem.eventType as string);

//   return `/taskDetails/${dataItem.taskNo}`;
// };

export default function SLADashboardDetail() {
  const [searchParams] = useSearchParams();
  const exporterRef = useRef<ExcelExport | null>(null);
  const { setStatus } = useContext(StatusContext);
  const navigate = useNavigate();
  const sourceDashboard = searchParams.get("sourceDashboard");
  const title = searchParams.get("title") || "SLA Tickets";
  const period = searchParams.get("period") || "all";
  const statusParam = searchParams.get("status") || "";
  const assignmentGroup = searchParams.get("assignmentGroup") || "";
  const fieldEngineer = searchParams.get("fieldEngineer") || "";
  const activityType = searchParams.get("activityType") || "";
  const customerId = searchParams.get("customerId") || "";
  const searchCriteria = searchParams.get("searchCriteria") || "";
  const eventCategory = (searchParams.get("eventCategory") ?? "SLA") as "SLA";
  const rawEventType = searchParams.get("eventType");
  const regions = searchParams.get("regions") || "";

  const isSiteNotAccessibleParam = searchParams.get("isSiteNotAccessible");

  const isSiteNotAccessible =
    isSiteNotAccessibleParam === "true" ? true : undefined;

  const eventType =
    rawEventType === null || rawEventType === "null" ? null : rawEventType;

  const type = searchParams.get("type");

  const pageNumberParam = Number(searchParams.get("pageNumber")) || 1;
  const pageRowCount = Number(searchParams.get("pageRowCount")) || PAGE_SIZE;

  const hasInvalidState = !title || !period;
  const parseNullableBoolean = (value: string | null) => {
    if (value === null || value === "null") return null;
    if (value === "true") return true;
    if (value === "false") return false;
    return null;
  };

  const isBreached =
    parseNullableBoolean(searchParams.get("isBreached")) ??
    (type === "breached" ? true : null);

  const isAboutToBreach =
    parseNullableBoolean(searchParams.get("isAboutToBreach")) ??
    (type === "aboutToBreach" ? true : null);

  const [pageNumber, setPageNumber] = useState(pageNumberParam);
  const [dataState, setDataState] = useState<State>({});

  useEffect(() => {
    if (hasInvalidState) {
      navigate("/slaDashboard", { replace: true });
    }
  }, [hasInvalidState, navigate]);

  useEffect(() => {
    const handleUnload = (e: BeforeUnloadEvent) => {
      if (sourceDashboard) {
        sessionStorage.setItem("redirectOnReload", buildDashboardReturnUrl());
      }
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [sourceDashboard]);

  useEffect(() => {
    const redirectUrl = sessionStorage.getItem("redirectOnReload");

    if (redirectUrl) {
      sessionStorage.removeItem("redirectOnReload");
      navigate(redirectUrl, { replace: true });
    }
  }, []);

  const {
    mutate: fetchSLADashboardDetail,
    data,
    isPending: isFetching,
  } = useGetSLADashboardDetail();
  const {
    mutate: exportExcel,
    data: exportData,
    isPending: exporting,
    reset,
  } = useExportSLADashboardDetail();

  useEffect(() => {
    if (hasInvalidState) return;

    fetchSLADashboardDetail({
      status: statusParam,
      period,
      assignmentGroup,
      fieldEngineer,
      activityType,
      customerId,
      regions,
      pageNumber,
      pageRowCount,
      searchCriteria,
      eventCategory,
      eventType: eventType ?? undefined,
      isBreached: isBreached ?? undefined,
      isAboutToBreach: isAboutToBreach ?? undefined,
      isSiteNotAccessible,
    });
  }, [
    statusParam,
    period,
    assignmentGroup,
    fieldEngineer,
    activityType,
    customerId,
    regions,
    pageNumber,
    pageRowCount,
    searchCriteria,
    eventCategory,
    eventType,
    isBreached,
    isAboutToBreach,
    isSiteNotAccessible,
    hasInvalidState,
    fetchSLADashboardDetail,
  ]);

  useEffect(() => {
    if (exportData?.data && exporterRef.current) {
      exporterRef.current.save();
      reset();
    }
  }, [exportData, reset]);

  const rawGridData = useMemo(
    () => (data?.data ? data.data : []),
    [data?.data],
  );

  const rawExportData = useMemo(
    () => (exportData?.data ? exportData.data : []),
    [exportData?.data],
  );

  const gridData = useMemo<
    (Record<string, unknown> & { currentSlaStage: string })[]
  >(() => {
    return rawGridData.map(
      (
        item: Record<string, unknown> & {
          responseSla?: SlaInfo;
          resolutionSla?: SlaInfo;
        },
      ) => {
        let currentSlaStage: string;

        if (eventType === "Response") {
          currentSlaStage = item.responseSla?.slaStage ?? "-";
        } else if (eventType === "Resolution") {
          currentSlaStage = item.resolutionSla?.slaStage ?? "-";
        } else {
          currentSlaStage =
            item.responseSla?.slaStage ?? item.resolutionSla?.slaStage ?? "-";
        }

        return {
          ...item,
          currentSlaStage,
        };
      },
    ) as (Record<string, unknown> & { currentSlaStage: string })[];
  }, [rawGridData, eventType]);

  const exportGridData = useMemo((): (Record<string, unknown> & {
    currentSlaStage: string;
  })[] => {
    return (
      rawExportData as (Record<string, unknown> & {
        responseSla?: SlaInfo;
        resolutionSla?: SlaInfo;
      })[]
    ).map((item) => {
      let currentSlaStage: string;
      if (eventType === "Response") {
        currentSlaStage = item.responseSla?.slaStage ?? "-";
      } else if (eventType === "Resolution") {
        currentSlaStage = item.resolutionSla?.slaStage ?? "-";
      } else {
        currentSlaStage =
          item.responseSla?.slaStage ?? item.resolutionSla?.slaStage ?? "-";
      }

      return {
        ...item,
        currentSlaStage,
      } as Record<string, unknown> & { currentSlaStage: string };
    });
  }, [rawExportData, eventType]);
  const showSlaStageColumn =
    eventType === "Response" ||
    eventType === "Resolution" ||
    eventType === null;

  const buildDashboardReturnUrl = () => {
    const params = new URLSearchParams();

    if (period && period !== "all") params.set("date", period);
    if (assignmentGroup) params.set("assignmentGroups", assignmentGroup);
    if (fieldEngineer) params.set("fieldEngineer", fieldEngineer);
    if (customerId) params.set("customers", customerId);
    if (activityType) params.set("activityTypes", activityType);

    return `${sourceDashboard}?${params.toString()}`;
  };
  if (hasInvalidState) {
    return null;
  }
  return (
    <div className="min-h-screen bg-gray-50 p-1 sm:p-2 lg:p-3">
      {isFetching || exporting ? <Loader /> : null}

      <BreadCrumb
        className="mb-4 mt-0"
        items={[
          {
            text: "SLA Dashboard",
            to: buildDashboardReturnUrl(),
          },
          { text: title },
        ]}
      />

      <Card className="bg-white shadow-md rounded-lg overflow-hidden">
        <CardContent className="p-6">
          <div className="flex justify-between items-center mb-5">
            <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            <Button
              variant="secondary"
              className="px-4 py-2 text-sm"
              onClick={() => {
                exportExcel({
                  status: statusParam,
                  period,
                  assignmentGroup,
                  activityType,
                  customerId,
                  searchCriteria,
                  eventCategory,
                  eventType,
                  isBreached,
                  isAboutToBreach,
                  isSiteNotAccessible,
                });
              }}
            >
              Export
            </Button>
          </div>

          <div className="overflow-x-auto rounded-md border border-gray-200">
            <Grid
              className="k-grid table-auto min-w-full"
              data={process(gridData, dataState)}
              pageable
              sortable
              total={data?.totalRecords || 0}
              pageSize={PAGE_SIZE}
              skip={(pageNumber - 1) * PAGE_SIZE}
              onPageChange={(e) => {
                setPageNumber(e.page.skip / PAGE_SIZE + 1);
              }}
              onDataStateChange={(e) => {
                setDataState(e.dataState);
              }}
            >
              <GridColumn
                field="alertDateTimeFormatted"
                title="Alert Date & Time"
                width="160px"
              />
              <GridColumn
                field="createDateTimeFormatted"
                title="Open At"
                width="160px"
              />
              <GridColumn field="status" title="Status" width="120px" />

              {showSlaStageColumn ? (
                <GridColumn
                  field="currentSlaStage"
                  title="Current SLA Stage"
                  width="180px"
                  cell={(items) => {
                    const { display, bgColor } = getSlaStageInfo(
                      items.dataItem.currentSlaStage as string | undefined,
                    );
                    return (
                      <td>
                        <div className="flex items-center justify-center">
                          {display ? (
                            <div
                              className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                              style={{
                                width: "120px",
                                backgroundColor: bgColor,
                                color:
                                  bgColor === "transparent"
                                    ? "#374151"
                                    : "#fff",
                              }}
                            >
                              {display}
                            </div>
                          ) : null}
                        </div>
                      </td>
                    );
                  }}
                />
              ) : null}

              <GridColumn
                field="caseNo"
                title="Case No"
                width="150px"
                cell={(items) => {
                  const dataItem = items.dataItem;
                  return (
                    <GridDataCopyCell
                      dataItem={dataItem}
                      field="caseNo"
                      customCell={
                        <td>
                          <Link to={getTicketDetailsPage(dataItem)}>
                            {dataItem.status === "Draft"
                              ? "View Draft"
                              : dataItem.caseNo}
                          </Link>
                        </td>
                      }
                    />
                  );
                }}
              />

              <GridColumn
                field="taskNo"
                title="Task No"
                width="150px"
                cell={(items) => {
                  const dataItem = items.dataItem;
                  if (!dataItem.taskNo) return <td>-</td>;
                  return (
                    <GridDataCopyCell
                      dataItem={dataItem}
                      field="taskNo"
                      customCell={
                        <td>
                          {dataItem.taskNo}
                          {/* optionally wrap in Link if needed */}
                          {/* <Link to={getTaskDetailsPage(dataItem)}>{dataItem.taskNo}</Link> */}
                        </td>
                      }
                    />
                  );
                }}
              />

              <GridColumn field="customer" title="Customer" width="200px" />
              <GridColumn field="locationId" title="Asset ID" width="150px" />
              <GridColumn field="locationName" title="Location" width="220px" />
              <GridColumn field="region" title="Region" width="150px" />
              <GridColumn
                field="assignmentGroup"
                title="Assignment Group"
                width="200px"
              />
              <GridColumn field="fault" title="Fault" width="220px" />
              <GridColumn field="remarks" title="Remarks" width="300px" />
              <GridColumn
                field="responseDurationFormatted"
                title="Response Duration"
                width="180px"
              />
              <GridColumn
                field="resolutionDurationFormatted"
                title="Resolution Duration"
                width="180px"
              />
              <GridColumn
                field="resolutionNotes"
                title="Resolution Notes"
                width="300px"
              />
              <GridColumn
                field="earliestServiceStartDateTimeFormatted"
                title="Started At"
                width="180px"
              />
              <GridColumn
                field="latestServiceEndDateTimeFormatted"
                title="Completed At"
                width="180px"
              />
              <GridColumn
                field="latestServiceCloseDateTimeFormatted"
                title="Closed At"
                width="180px"
              />
            </Grid>
          </div>

          <ExcelExport
            data={exportGridData}
            fileName={`${title}.xlsx`}
            ref={exporterRef}
          >
            <GridColumn
              field="alertDateTimeFormatted"
              title="Alert Date & Time"
            />
            <GridColumn field="createDateTimeFormatted" title="Open At" />
            <GridColumn field="status" title="Status" />

            {showSlaStageColumn ? (
              <GridColumn field="currentSlaStage" title="Current SLA Stage" />
            ) : null}

            <GridColumn field="caseNo" title="Case No" />
            <GridColumn field="taskNo" title="Task No" />
            <GridColumn field="customer" title="Customer" />
            <GridColumn field="locationId" title="Asset ID" />
            <GridColumn field="locationName" title="Location" />
            <GridColumn field="region" title="Region" />
            <GridColumn field="assignmentGroup" title="Assignment Group" />
            <GridColumn field="fault" title="Fault" />
            <GridColumn field="remarks" title="Remarks" />
            <GridColumn
              field="responseDurationFormatted"
              title="Response Duration"
            />
            <GridColumn
              field="resolutionDurationFormatted"
              title="Resolution Duration"
            />
            <GridColumn field="resolutionNotes" title="Resolution Notes" />
            <GridColumn
              field="earliestServiceStartDateTimeFormatted"
              title="Started At"
            />
            <GridColumn
              field="latestServiceEndDateTimeFormatted"
              title="Completed At"
            />
            <GridColumn
              field="latestServiceCloseDateTimeFormatted"
              title="Closed At"
            />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
